import Home from './pages/Home';
import Login from './pages/Login';
import Editor from './pages/Editor';
import Event from './pages/Event';
import Activity from './pages/Activity';
import Present from './pages/Present';
import Slideshow from './pages/Slideshow';
import Room from 'src/pages/Room/Room';
import RoomConfigure from 'src/pages/RoomConfigure';
import Task from 'src/pages/Task';
import ImageViewer from 'src/pages/ImageViewer';
import EventProgress from './pages/Event/EventProgress.js';
import EventScoring from 'src/pages/Event/EventScoring';
import Settings from './pages/Settings';

import TradingWars from './pages/TradingWars';
import TradingWarsEditor from './pages/TradingWarsEditor';
import TradingWarsMomentEditor from './pages/TradingWarsEditor/moment';

import Billing from './pages/Billing';

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { AppProvider, useApp } from './appContext';


function App() {
	const { isAuthenticated, isLoaded } = useApp();
	// if (user?.signInUserSession?.accessToken) axios.defaults.headers.common.Authorization = user.signInUserSession.accessToken.jwtToken;

	return (
		<div className="App">
			<Router>
				<Switch>
					<Route path="/present/:id" exact component={Present} />

					{
						// Only the presenter screen (used by the bots) is public. Everything else needs a login.
						!isLoaded ? null : isAuthenticated ? (
							<>
								<Route exact path="/" component={Home} />
								<Route path="/images" exact component={ImageViewer} />
								<Route path="/event/:id" exact children={<Event />} />
								<Route path="/event/:id/scoring" exact children={<EventScoring />} />
								<Route path="/game/:id/progress" exact children={<EventProgress />} />
								<Route path="/slideshow/:id" exact component={Slideshow} />
								<Route path="/billing" exact children={<Billing />} />
								<Route path="/trading-wars" exact children={<TradingWars />} />
								<Route path="/settings" exact component={Settings} />
								<Route path="/activity/editor/:id" exact component={Editor} />
								<Route path="/activity/:id" exact component={Activity} />
								<Route path="/room/:id" exact component={Room} />
								<Route path="/room/:id/configure" exact component={RoomConfigure} />
								<Route path="/task/:id" exact component={Task} />
								<Route path="/trading-wars/editor" exact children={<TradingWarsEditor />} />
								<Route path="/trading-wars/editor/moment/:id" exact children={<TradingWarsMomentEditor />} />
							</>
						) : (
							<Route path="/" component={Login} />
						)
					}
				</Switch>
			</Router>
		</div>
	);
}

export default () => (
	<AppProvider>
		<App />
	</AppProvider>
);
